export enum CustomerCreditTransactionType {
  ISSUED = "ct111111-1111-1111-1111-111111111111",
  RECEIVED = "ct222222-2222-2222-2222-222222222222",
  PAYMENT_MADE = "ct444444-4444-4444-4444-444444444444",
}

export const CustomerCreditTransactionTypeInfo = {
  [CustomerCreditTransactionType.ISSUED]: {
    code: "credit_issued",
    name: "Credit Issued",
  },
  [CustomerCreditTransactionType.RECEIVED]: {
    code: "payment_received",
    name: "Credit Payment Received",
  },
  [CustomerCreditTransactionType.PAYMENT_MADE]: {
    code: "payment_made",
    name: "Credit Payment Made",
  },
} as const;

export const getCustomerCreditTransactionTypeCode = (
  value: CustomerCreditTransactionType,
): string => CustomerCreditTransactionTypeInfo[value].code;
export const getCustomerCreditTransactionTypeName = (
  value: CustomerCreditTransactionType,
): string => CustomerCreditTransactionTypeInfo[value].name;
